import { useRef, useState } from 'react'
import ReactTooltip from 'react-tooltip'
import classNames from 'classnames'
import Text from '@components/Ui/Text'
import Icon from '@components/Ui/Icon'
import Spacer from '@components/Ui/Spacer'
import { useMediaQueryContext } from '@context'
import { useOnClickOutside } from '@hooks'
import styles from './TypeSelectButton.scss'

const TypeSelectButton = ({ title, subtitle, icon, image, svg, active, info, onClick }) => {
  const rootRef = useRef()
  const buttonRef = useRef()
  const { touch } = useMediaQueryContext()
  const [isActive, setIsActive] = useState(false)

  useOnClickOutside(buttonRef, () => {
    if (isActive) {
      setIsActive(false)
    }
  })

  const maybeOnClick = (e) => {
    if (e.target === buttonRef.current || buttonRef.current.contains(e.target)) {
      return
    }
    onClick()
  }

  return (
    <button
      type="button"
      className={classNames(styles.base, { [styles.active]: active })}
      data-e2e="appointments-type"
      onClick={maybeOnClick}
      ref={rootRef}
    >
      <div className={styles.activeButton}>
        <Icon type="check" size="20" />
      </div>
      <div
        className={styles.infoButton}
        ref={buttonRef}
        data-tip={info}
        data-for="type-button"
        onClick={() => touch && setIsActive(true)}
      >
        <ReactTooltip
          id="type-button"
          place="top"
          type="dark"
          effect="solid"
          multiline
          className={styles.tooltip}
          disable={false}
        />

        {/*{touch && isActive && <div className={styles.touchOverlay}>{info}</div>}*/}
        <Icon type="info" size="20" />
      </div>
      <div className={styles.icon}>
        {/*<img src={image} alt="" />*/}
        {svg && <div dangerouslySetInnerHTML={{ __html: svg }} />}
      </div>
      <Spacer scale="0.5" vertical />
      <Text type="robo_xmd_bold" className={styles.title}>
        {title}
      </Text>
      {subtitle && (
        <Text type="robo_md" className={styles.subtitle}>
          {subtitle}
        </Text>
      )}
    </button>
  )
}

TypeSelectButton.defaultProps = {
  title: '',
  subtitle: '',
  active: false,
  info: null,
  icon: null,
  onClick: () => {},
}
TypeSelectButton.propTypes = {}

export default TypeSelectButton
